<script setup lang="ts">
import type { ToastDescriptionProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { ToastDescription } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	ToastDescriptionProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});
</script>

<template>
	<ToastDescription
		:class="cn('text-sm opacity-90', props.class)"
		v-bind="delegatedProps"
	>
		<slot />
	</ToastDescription>
</template>
